module.exports = __webpack_public_path__ + "img/premium_active_mobile.20f9d522.png";